/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import CartesianCoordinates from '../interactive/CartesianCoordinates';
export const metadata = {
  title: '3D Coordinates',
  demo: () => <CartesianCoordinates dimensions={3} perspective={0} mdxType="CartesianCoordinates" />
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In 3D coordinates, we add one more dimension so that we end up with `}<inlineCode parentName="p">{`(x, y, z)`}</inlineCode>{`.`}</p>
    <p>{`Shift the perspective below to see the third dimension:`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
